import type { ActionHandler } from '../types'

async function adjustFatigue(ctx: { characterId: string; supabase: import('@supabase/supabase-js').SupabaseClient }, delta: number) {
  const { data: char } = await ctx.supabase
    .from('characters')
    .select('fatigue_levels')
    .eq('id', ctx.characterId)
    .single()

  if (!char) throw new Error('Character not found')

  const oldVal = char.fatigue_levels
  const newVal = Math.max(0, oldVal + delta)

  const { error } = await ctx.supabase
    .from('characters')
    .update({ fatigue_levels: newVal })
    .eq('id', ctx.characterId)

  if (error) throw error

  return {
    effects: [{
      character_id: ctx.characterId,
      target_table: 'characters',
      target_row_id: ctx.characterId,
      target_field: 'fatigue_levels',
      operation: 'UPDATE' as const,
      old_value: oldVal,
      new_value: newVal,
    }],
    label: delta > 0 ? `+${delta} fatigue (now ${newVal})` : `−${Math.abs(delta)} fatigue (now ${newVal})`,
  }
}

export const handleAddFatigue: ActionHandler<'ADD_FATIGUE'> = (ctx, payload) =>
  adjustFatigue(ctx, payload.amount)

export const handleRemoveFatigue: ActionHandler<'REMOVE_FATIGUE'> = (ctx, payload) =>
  adjustFatigue(ctx, -payload.amount)
